import { Component, HostListener, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AlertController, ToastController } from '@ionic/angular';
import { NaploService } from '../naplo.service';
import { tablazatBeolvas } from '../tablazat-beolvas';
import * as XLSX from 'xlsx';

// NAPLO – Bank (Adriana V2). Fázis 1: Aggreg8 meghatalmazás (mandate) + tranzakció-szinkron.
// Az n8n kiváltva; a banki hívások a natív /api/naplo-bank backendre mennek (az Aggreg8-elérés
// a fix-IP api.cronom.it relén át a backendben). Fázis 2-ben jön az automata kontírozó.
@Component({
  selector: 'app-naplo-bank',
  templateUrl: './bank.component.html',
  styleUrls: ['../naplo-shared.scss', './bank.component.scss'],
})
export class BankComponent implements OnInit {
  private readonly base = '/api/naplo-bank';
  get aktiv() { return this.naplo.aktiv; }
  //  Egyszeres könyvvitelnél a kontír a naplófőkönyv rovata, a könyvelés naplófőkönyvi tétel (Bank pénztár).
  get egyszeres() { return this.aktiv.konyveles_mod !== 'kettos'; }

  szamlak: any[] = [];
  tranzakciok: any[] = [];
  szinkronFut: string | null = null;
  mandateVar = false;        // épp folyamatban egy meghatalmazás (visszatéréskor ellenőrizzük)
  ellenorzFut = false;
  ujSzamla: any = null;             // kézi számla-felvétel
  szuro = { bank_id: '', statusz: '' as string, tol: '', ig: '' };
  // --- kontírozó (Fázis 2) ---
  kontirFut = false;
  veglegesitFut = false;
  /*  A KONTÍROZÁS KÉT FÜLE: 'javaslat' = a kontír-javaslat közvetlenül az oldalon (korábban egy
   *  gombbal nyitott ablakban volt), 'tortenet' = Számlatörténet, a banki tételek teljes listája
   *  (szűrés, kézi kontír, visszavonás). A javaslat az oldal megnyitásakor magától betöltődik. */
  ful: 'javaslat' | 'tortenet' = 'javaslat';
  javaslatUjra = false;             // a már kontírozott tételekre is kérjen javaslatot (a régi „Mindenre")
  //  A Számlatörténet fülön végzett módosítás (kézi kontír, visszavonás, könyvelés) után a
  //  javaslat elavulhat – a fülre visszaváltáskor ilyenkor újrakérjük.
  javaslatElavult = false;
  javaslatok: any[] = [];           // a motor javaslatai (áttekintés/módosítás után véglegesíthető)
  //  Dátumszűrő a kontír-javaslat fülön (yyyy-MM-dd; üres = nincs korlát).
  //  A Mind/kijelölés/Mehet a SZŰRT (látható) sorokra hat, hogy rejtett sor ne mentődjön véletlenül.
  javaszTol = '';
  javaszIg = '';
  get javaslatokSzurve(): any[] {
    const t = this.javaszTol ? new Date(this.javaszTol + 'T00:00:00').getTime() : null;
    const i = this.javaszIg ? new Date(this.javaszIg + 'T23:59:59').getTime() : null;
    if (t == null && i == null) return this.javaslatok;
    return this.javaslatok.filter((j) => {
      const d = j?.datum ? new Date(j.datum).getTime() : NaN;
      if (isNaN(d)) return false;
      if (t != null && d < t) return false;
      if (i != null && d > i) return false;
      return true;
    });
  }
  javaslatSzuroTorol() { this.javaszTol = ''; this.javaszIg = ''; }
  // bontásos kipontozó-szerkesztő (egy tranzakció több számlára)
  bontasTr: any = null;
  bontasSorok: any[] = [];
  bontasFut = false;
  szerkesztTr: any = null;          // soronkénti kézi kontír (modal)
  szabalyok: any[] = [];
  szabalyModal = false;
  ujSzabaly: any = null;
  // Számlatükör + főkönyvi-szám választó (a kontírozóhoz)
  tukor: any[] = [];
  fkPicker: { open: boolean; cel: any; mezo: string; kereses: string } = { open: false, cel: null, mezo: '', kereses: '' };
  // RLB partner-alias (banki név → RLB-név) az exporthoz
  aliasModal = false;
  aliasok: any[] = [];
  ujAlias: { minta: string; rlb_nev: string } = { minta: '', rlb_nev: '' };
  bankiNevek: string[] = [];   // a banki tranzakciók partnernevei (a "Banki név" választáshoz)
  torzsNevek: string[] = [];   // az RLB partnertörzs nevei (a "saját listám" az RLB-névhez) – SOSE szűrve
  /*  KÉZI DEVIZÁSÍTÁS – ha a közleményből nem derül ki a deviza. A tétel ezután úgy viselkedik,
   *  mintha a közleményben állt volna: párosítás, árfolyam-különbözet és export is ezzel számol. */
  readonly DEVIZANEMEK = ['EUR', 'USD', 'GBP', 'CHF', 'PLN', 'CZK', 'RON', 'SEK', 'NOK', 'DKK', 'JPY', 'BGN'];
  /** A bank tényleges árfolyama: forint / deviza (4 tizedesre), vagy null. */
  devizaArfolyam(x: any): number | null {
    const dev = Math.abs(Number(String(x?.deviza_osszeg ?? '').replace(',', '.')));
    const nem = String(x?.deviza_nem || '').toUpperCase();
    if (!(dev > 0) || !nem || nem === 'HUF') return null;
    return Math.round((this.abs(x.osszeg) / dev) * 10000) / 10000;
  }
  devizaKapcs(j: any) {
    j.devizaSzerk = !j.devizaSzerk;
    if (j.devizaSzerk && !j.deviza_nem) j.deviza_nem = 'EUR';
  }
  /** A kontír-javaslat sorában a deviza átírása: a párosítás és az előnézet az új devizával számol újra. */
  javaslatDevizaValt(j: any) {
    j.devizaModositva = true;
    const id = this.egyszeruSzamlaId(j);
    if (id && id !== 'TOBB') this.egyszeruValaszt(j, id); else this.arfolyamElonezet(j);
  }
  /** A partner-felülíráshoz felkínált nevek: az RLB-törzs (vagy könyvelési partnertörzs) nevei. */
  get partnerNevek(): string[] { return this.torzsNevek; }
  private async partnerNevekBetolt() {
    if (this.torzsNevek.length || !this.aktiv?.ugyfelId) return;
    try { const nl: any = await this.get(`/${this.aktiv.ugyfelId}/rlb-nevlistak`); this.torzsNevek = nl?.torzs || []; this.bankiNevek = nl?.banki || []; }
    catch { /* a felülírás kézzel is beírható */ }
  }
  // A bal oldali (Banki név) legördülőben CSAK a még össze nem vezetett (alias nélküli) partnerek.
  // A jobb oldali (RLB-név) SOSE szűrt: több banki partner is mutathat ugyanarra az RLB-partnerre.
  get bankiNevekSzabad(): string[] {
    const foglalt = new Set(this.aliasok.map((a) => String(a.minta || '').trim().toLowerCase()));
    return this.bankiNevek.filter((n) => !foglalt.has(String(n).trim().toLowerCase()));
  }
  readonly TIPUSOK = [
    { k: 'vevo', c: 'Vevő (bevétel)' }, { k: 'szallito', c: 'Szállító (kiadás)' },
    { k: 'nav', c: 'NAV / adó' }, { k: 'bankkoltseg', c: 'Bankköltség' },
    { k: 'ber', c: 'Bér / járulék' }, { k: 'atvezetes', c: 'Átvezetés' }, { k: 'fuggo', c: 'Függő' },
  ];
  tipusCimke(k: string) { return this.TIPUSOK.find((x) => x.k === k)?.c || k || '—'; }
  //  Egyszeres: a rovat fő oszlopa dönti el, bevétel vagy kiadás (1–2 bevétel); az ellenirányú tétel negatív.
  naploIrany(t: any): string {
    const r = (this.tukor || []).find((s) => s.szamlaszam === t.fokonyvi_szam);
    if (!r) return (Number(t.osszeg) || 0) >= 0 ? 'Bevétel' : 'Kiadás';
    const bev = [1, 2].includes(Number(r.oszlop));
    return (bev ? 'Bevétel' : 'Kiadás') + (bev === ((Number(t.osszeg) || 0) >= 0) ? '' : ' (−)');
  }
  // T/K a bank főkönyvi + előjel alapján (a kontírozott ellenszámlával szemben)
  tk(t: any): { t: string; k: string } {
    const bank = t.bank_fokonyvi || '384'; const ell = t.fokonyvi_szam || '?';
    return (Number(t.osszeg) || 0) >= 0 ? { t: bank, k: ell } : { t: ell, k: bank };
  }
  // szinkron-dátumtartomány (a felhasználó állíthatja); alapból az utolsó 90 nap. ÉÉÉÉ-HH-NN.
  szinkronTartomany = { tol: BankComponent.napokEzelott(90), ig: BankComponent.ma() };
  private static ma() { return new Date().toISOString().slice(0, 10); }
  private static napokEzelott(n: number) { return new Date(Date.now() - n * 86400000).toISOString().slice(0, 10); }

  constructor(private http: HttpClient, private naplo: NaploService, private toast: ToastController, private alert: AlertController,
              private route: ActivatedRoute) {}

  /*  A BANK KÉT OLDALRA VÁLT: 'szamlak' = Bankszámlák (összekötés, szinkron, meghatalmazás),
   *  'kontir' = Bank kontírozás (tételek, javaslat, párosítás, könyvelés, RLB-feladás).
   *  Ugyanaz a komponens, a route-adat választja ki, melyik rész látszik – így a kontír a saját
   *  menüpontjából nyílik, a logika pedig egy helyen marad. */
  nezet: 'szamlak' | 'kontir' = 'szamlak';

  /* ══════════ V/SZ SZÁMLÁK KIEGYENLÍTÉSE (kipontozó ablak) ══════════
   *  Egy helyen a nyitott vevő/szállító számlák és a még ki nem pontozott banktételek: a
   *  kijelölésből a rendszer elkészíti a kiosztást. Nem csak 1:1 megy – EGY banktétel több
   *  számlát is fedezhet, és EGY számlát több banktétel is kiegyenlíthet (részfizetés);
   *  a kiosztás esedékesség szerint, sorban tölti fel a számlákat, ameddig a pénz tart.
   *  A mentés a kontírozás véglegesítőjén keresztül megy, tehát ugyanazt írja (párosítás JSON,
   *  kiegyenlített összeg, állapot, bizonylat), mint a kontír-ablak. */
  vszModal = false;
  vszFut = false;
  vszSzamlak: any[] = [];
  vszTetelek: any[] = [];
  vszKijeloltSzamla = new Set<string>();
  vszKijeloltTetel = new Set<string>();
  vszSzuro = { kereses: '', mod: 'eleje' as 'eleje' | 'tartalmaz', vevo: true, szallito: true, rendezett: false, deviza: '' };

  async vszNyit() {
    this.vszModal = true;
    this.vszKijeloltSzamla.clear(); this.vszKijeloltTetel.clear();
    await this.vszBetolt();
  }
  async vszBetolt() {
    if (!this.aktiv.ugyfelId) return;
    this.vszFut = true;
    try {
      const mind = this.vszSzuro.rendezett ? '?mind=1' : '';
      this.vszSzamlak = await this.get(`/${this.aktiv.ugyfelId}/nyitott-szamlak${mind}`);
      //  banktételek: ami még nincs kipontozva (a párosítottat előbb vissza kell vonni)
      const t: any[] = await this.get(`/${this.aktiv.ugyfelId}/tranzakciok`);
      this.vszTetelek = (t || []).filter((x) => x.statusz !== 'parositott' && x.statusz !== 'konyvelt');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült betölteni a kiegyenlítéshez a tételeket.'); }
    finally { this.vszFut = false; }
  }
  private vszIllik(szoveg: string) {
    const k = this.vszSzuro.kereses.trim().toLowerCase();
    if (!k) return true;
    const sz = String(szoveg || '').toLowerCase();
    return this.vszSzuro.mod === 'eleje' ? sz.startsWith(k) : sz.includes(k);
  }
  get vszSzamlaSorok(): any[] {
    return (this.vszSzamlak || []).filter((s) => {
      if (s.tipus === 'vevo' && !this.vszSzuro.vevo) return false;
      if (s.tipus === 'szallito' && !this.vszSzuro.szallito) return false;
      if (this.vszSzuro.deviza && (s.deviza || 'HUF') !== this.vszSzuro.deviza) return false;
      return this.vszIllik(s.bizonylatszam) || this.vszIllik(s.partner_nev);
    });
  }
  get vszTetelSorok(): any[] {
    return (this.vszTetelek || []).filter((t) => {
      const poz = Number(t.osszeg) > 0;
      if (poz && !this.vszSzuro.vevo) return false;
      if (!poz && !this.vszSzuro.szallito) return false;
      if (this.vszSzuro.deviza && (t.devizanem || 'HUF') !== this.vszSzuro.deviza) return false;
      return this.vszIllik(t.partner_nev) || this.vszIllik(t.kozlemeny);
    });
  }
  vszSzamlaValt(s: any) { this.vszKijelolesValt(this.vszKijeloltSzamla, s.id); }
  vszTetelValt(t: any) { this.vszKijelolesValt(this.vszKijeloltTetel, t.id); }
  private vszKijelolesValt(halmaz: Set<string>, id: string) { halmaz.has(id) ? halmaz.delete(id) : halmaz.add(id); }
  vszMindSzamla(be: boolean) { this.vszKijeloltSzamla = new Set(be ? this.vszSzamlaSorok.filter((s) => (s.deviza || 'HUF') === 'HUF').map((s) => s.id) : []); }
  vszMindTetel(be: boolean) { this.vszKijeloltTetel = new Set(be ? this.vszTetelSorok.filter((t) => (t.devizanem || 'HUF') === 'HUF').map((t) => t.id) : []); }

  get vszSzamlaOssz() { return this.vszSzamlaSorok.filter((s) => this.vszKijeloltSzamla.has(s.id)).reduce((a, s) => a + (Number(s.hatralek) || 0), 0); }
  get vszTetelOssz() { return this.vszTetelSorok.filter((t) => this.vszKijeloltTetel.has(t.id)).reduce((a, t) => a + Math.abs(Number(t.osszeg) || 0), 0); }
  get vszKulonbozet() { return Math.round((this.vszTetelOssz - this.vszSzamlaOssz) * 100) / 100; }

  /*  A KIOSZTÁS. Előjel dönt: a jóváírás vevői, a terhelés szállítói számlát fedez. A kijelölt
   *  számlákat esedékesség szerint töltjük fel, amíg a kijelölt banktételek pénze tart – így
   *  jön ki az 1:1, az egy tétel → több számla és a több tétel → egy számla eset is. */
  private vszKiosztas() {
    const szamlak = this.vszSzamlaSorok.filter((s) => this.vszKijeloltSzamla.has(s.id) && (s.deviza || 'HUF') === 'HUF')
      .map((s) => ({ ...s, marad: Number(s.hatralek) || 0 }))
      .sort((a, b) => String(a.fizetesi_hatarido || a.kelt).localeCompare(String(b.fizetesi_hatarido || b.kelt)));
    const tetelek = this.vszTetelSorok.filter((t) => this.vszKijeloltTetel.has(t.id) && (t.devizanem || 'HUF') === 'HUF')
      .sort((a, b) => String(a.datum).localeCompare(String(b.datum)));
    const terv: any[] = [];
    for (const t of tetelek) {
      const tipus = Number(t.osszeg) > 0 ? 'vevo' : 'szallito';
      let keret = Math.abs(Number(t.osszeg) || 0);
      const reszek: any[] = [];
      for (const s of szamlak) {
        if (keret <= 0.5) break;
        if (s.tipus !== tipus || s.marad <= 0.5) continue;
        const ad = Math.min(keret, s.marad);
        reszek.push({ szamla_id: s.id, osszeg: Math.round(ad * 100) / 100, bizonylatszam: s.bizonylatszam });
        s.marad = Math.round((s.marad - ad) * 100) / 100;
        keret = Math.round((keret - ad) * 100) / 100;
      }
      if (reszek.length) terv.push({ id: t.id, tipus, reszek, marad: keret, tetel: t });
    }
    return { terv, szamlak };
  }

  /** A kiosztás mentése – a kontírozás véglegesítőjén át, hogy ugyanaz íródjon, mint kézi kontírnál. */
  async vszKiegyenlit() {
    const { terv } = this.vszKiosztas();
    if (!terv.length) return this.hiba('Nincs mit kiegyenlíteni: jelölj ki legalább egy banktételt és egy hozzá illő számlát.');
    const osszeg = terv.reduce((a, x) => a + x.reszek.reduce((b: number, r: any) => b + r.osszeg, 0), 0);
    const marad = terv.reduce((a, x) => a + x.marad, 0);
    const a = await this.alert.create({
      header: 'Vevő/szállító kiegyenlítés',
      message: `${terv.length} banktétel → ${terv.reduce((n, x) => n + x.reszek.length, 0)} számla-részlet, összesen `
        + `${osszeg.toLocaleString('hu-HU')} Ft.` + (marad > 0.5 ? `<br>Kiosztatlan marad: ${marad.toLocaleString('hu-HU')} Ft.` : ''),
      buttons: ['Mégse', { text: 'Kiegyenlítés', handler: () => this.vszKiegyenlitFut(terv) }],
    });
    await a.present();
  }
  private async vszKiegyenlitFut(terv: any[]) {
    this.vszFut = true;
    try {
      //  a kontír-motor mondja meg a tételekhez az ellenszámlát (ugyanaz, amit a javaslat adna)
      const j: any = await this.post(`/${this.aktiv.ugyfelId}/kontir-javaslat`, { ids: terv.map((x) => x.id) });
      const fok = new Map((j?.javaslatok || []).map((x: any) => [x.id, x.fokonyvi_szam]));
      const tetelek = terv.map((x) => ({ id: x.id, tipus: x.tipus, fokonyvi_szam: fok.get(x.id) || x.tetel.fokonyvi_szam || null,
        parositasok: x.reszek.map((r: any) => ({ szamla_id: r.szamla_id, osszeg: r.osszeg })) }));
      const r: any = await this.post(`/${this.aktiv.ugyfelId}/kontir-veglegesit`, { tetelek });
      this.ok(`Kiegyenlítve: ${r?.parositott ?? tetelek.length} banktétel kipontozva.`);
      if (r?.kihagyva?.length) this.hiba(`${r.kihagyva.length} tétel kimaradt (már párosított vagy könyvelt) – előbb vissza kell vonni.`);
      this.vszKijeloltSzamla.clear(); this.vszKijeloltTetel.clear();
      await this.vszBetolt();
      await this.tranzakcioBetolt();
    } catch (e: any) { this.hiba(e?.error?.error || 'A kiegyenlítés nem sikerült.'); }
    finally { this.vszFut = false; }
  }

  private get<T = any>(p: string) { return firstValueFrom(this.http.get<T>(this.base + p)); }
  private post<T = any>(p: string, b: any) { return firstValueFrom(this.http.post<T>(this.base + p, b)); }
  private put<T = any>(p: string, b: any) { return firstValueFrom(this.http.put<T>(this.base + p, b)); }
  private del<T = any>(p: string) { return firstValueFrom(this.http.delete<T>(this.base + p)); }

  async ngOnInit() {
    this.nezet = this.route.snapshot.data?.['nezet'] === 'kontir' ? 'kontir' : 'szamlak';
    await this.naplo.init();
    if (this.aktiv.ugyfelId) { this.betolt(); }
  }

  async betolt() {
    try { this.szamlak = await this.get(`/${this.aktiv.ugyfelId}/szamlak`); } catch { this.szamlak = []; }
    this.rlbSegedBetolt();
    this.rlbArfolyamBetolt();
    // Számlatükör a főkönyvi-szám választóhoz (a kettős-könyvelés végpontjáról); egyszeresnél a naplófőkönyv rovatai.
    try {
      this.tukor = this.egyszeres
        ? ((await firstValueFrom(this.http.get<any[]>('/api/naplo/rovatok/' + this.aktiv.ugyfelId))) || [])
          .filter((r) => r.tipus === 'rovat' && r.oszlop != null).map((r) => ({ szamlaszam: String(r.rovatszam), nev: r.nev, oszlop: r.oszlop }))
        : (await firstValueFrom(this.http.get<any[]>('/api/kettos/szamlatukor/' + this.aktiv.ugyfelId))) || [];
    } catch { this.tukor = []; }
    this.tranzakcioBetolt();
    //  A kontírozás nézet alapfüle maga a javaslat → gombnyomás nélkül betöltjük (a motor nem ír).
    if (this.nezet === 'kontir') this.kontirJavaslat();
  }

  fulValt(f: 'javaslat' | 'tortenet') {
    this.ful = f;
    if (f === 'javaslat' && this.javaslatElavult && !this.kontirFut) this.kontirJavaslat();
  }

  // ── Főkönyvi-szám választó (számlatükörből) ─────────────────────────────────
  fkNyit(cel: any, mezo: string) { this.fkPicker = { open: true, cel, mezo, kereses: '' }; }
  //  trackBy: a lista getter-ként minden CD-nél új tömböt ad; trackBy nélkül a DOM újraépülne, és egy
  //  egérlenyomás alatti újraépítés elronthatná a `click`-et (lásd naplok.component muveletek-javítás).
  fkTrack = (_: number, s: any) => s?.szamlaszam;
  fkSzurt() {
    const q = (this.fkPicker.kereses || '').trim().toLowerCase();
    const lista = (this.tukor || []).filter((s) => !s.gyujto);   // gyűjtőre nem kontírozunk
    if (!q) return lista.slice(0, 200);
    return lista.filter((s) => `${s.szamlaszam} ${s.nev || ''}`.toLowerCase().includes(q)).slice(0, 200);
  }
  fkValaszt(sz: any) {
    if (this.fkPicker.cel) this.fkPicker.cel[this.fkPicker.mezo] = sz.szamlaszam;
    this.fkPicker.open = false;
  }
  fkNev(szamla: string) { return (this.tukor || []).find((s) => s.szamlaszam === szamla)?.nev || ''; }

  // ── RLB partner-alias (banki név → RLB-név) ─────────────────────────────────
  async aliasNyit() {
    this.aliasModal = true; this.ujAlias = { minta: '', rlb_nev: '' };
    try { this.aliasok = await this.get(`/${this.aktiv.ugyfelId}/rlb-alias`); } catch { this.aliasok = []; }
    try {
      const nl: any = await this.get(`/${this.aktiv.ugyfelId}/rlb-nevlistak`);
      this.bankiNevek = nl?.banki || []; this.torzsNevek = nl?.torzs || [];
    } catch { this.bankiNevek = []; this.torzsNevek = []; }
  }
  async aliasHozzaad() {
    const minta = (this.ujAlias.minta || '').trim(), rlb_nev = (this.ujAlias.rlb_nev || '').trim();
    if (!minta || !rlb_nev) return this.hiba('A banki név és az RLB-név is kötelező.');
    try {
      await this.post(`/${this.aktiv.ugyfelId}/rlb-alias`, { minta, rlb_nev });
      this.ujAlias = { minta: '', rlb_nev: '' };
      this.aliasok = await this.get(`/${this.aktiv.ugyfelId}/rlb-alias`);
      this.ok('Partner-alias mentve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'A mentés nem sikerült.'); }
  }
  aliasKitolt(t: any) { this.ujAlias = { minta: t?.partner_nev || '', rlb_nev: t?.partner_nev || '' }; }
  async aliasTorol(a: any) {
    try { await this.del(`/${this.aktiv.ugyfelId}/rlb-alias/${a.id}`); this.aliasok = this.aliasok.filter((x) => x.id !== a.id); }
    catch (e: any) { this.hiba(e?.error?.error || 'A törlés nem sikerült.'); }
  }
  // RLB partnertörzs importálása (XLS/XLSX, SheetJS-szel parse-olva) → JSON a backendnek.
  rlbImportFut = false;
  async rlbPartnerImport(ev: any) {
    const file = ev?.target?.files?.[0];
    if (!file) return;
    this.rlbImportFut = true;
    try {
      // DBF-et a SZERVER olvas (a böngésző SheetJS-e nem ismeri fel a formátumot, és a
      // kódlapot – CP852/CP1250 – is a fájl fejléce adja meg); minden mást itt parse-olunk.
      const { partnerek, dbf } = await tablazatBeolvas(file);
      if (!dbf) {
        if (!partnerek.length) throw new Error('a fájlban nem találtam sorokat');
        const oszlopok = Object.keys(partnerek[0] || {});
        if (!oszlopok.some((o) => /^(partnev|nev)$/i.test(o))) {
          throw new Error(`nincs „partnev"/„nev" oszlop. Amit találtam: ${oszlopok.slice(0, 12).join(', ')}`);
        }
      }
      const r: any = await this.post(`/${this.aktiv.ugyfelId}/rlb-partner-import`, dbf ? { dbf } : { partnerek });
      const nl: any = await this.get(`/${this.aktiv.ugyfelId}/rlb-nevlistak`);
      this.torzsNevek = nl?.torzs || [];
      this.ok(`RLB partnertörzs importálva: ${r?.db || 0} partner (${file.name}).`);
    } catch (e: any) {
      this.hiba('Az import nem sikerült: ' + (e?.error?.error || e?.message || e));
    } finally { this.rlbImportFut = false; if (ev?.target) ev.target.value = ''; }
  }
  // Automatikus összevezetés: banki partnerek → RLB partnerek (bankszámla/név), alias-generálással.
  rlbOsszFut = false;
  async rlbOsszevezet() {
    this.rlbOsszFut = true;
    try {
      const r: any = await this.post(`/${this.aktiv.ugyfelId}/rlb-osszevezet`, {});
      this.aliasok = await this.get(`/${this.aktiv.ugyfelId}/rlb-alias`);
      this.ok(`Összevezetés: ${r.parositva}/${r.bankPartnerek} banki partner párosítva, ${r.uj} új alias${r.nemTalalt ? `, ${r.nemTalalt} nem talált RLB-párt` : ''}.`);
    } catch (e: any) {
      this.hiba(e?.error?.error || 'Az összevezetés nem sikerült.');
    } finally { this.rlbOsszFut = false; }
  }
  async tranzakcioBetolt() {
    const qs = new URLSearchParams(Object.entries(this.szuro).filter(([, v]) => v) as any).toString();
    try { this.tranzakciok = await this.get(`/${this.aktiv.ugyfelId}/tranzakciok${qs ? '?' + qs : ''}`); } catch { this.tranzakciok = []; }
  }
  // a meghatalmazás-státusz a lejárati dátumból
  lejarKozel(b: any): boolean {
    if (!b.mandate_lejarat) return false;
    const napok = (new Date(b.mandate_lejarat).getTime() - Date.now()) / 86400000;
    return napok >= 0 && napok <= 14;
  }
  // Hány BANKI nap (hétfő–péntek) telt el az utolsó ELÉRHETŐ tétel óta? A `mandate_lejarat` csak a
  // saját nyilvántartásunk (felvételkor +6 hó) – a valódi jelzés az, hogy jön-e még friss adat.
  adatElmaradas(b: any): number | null {
    if (!b?.utolso_tetel_datum) return null;
    // A DATE a szerverről UTC ISO-ként jön (…T22:00:00Z), a .slice(0,10) EGY NAPPAL visszább vinné;
    // Date-ként parse-olva + helyi éjfélre állítva azt a naptári napot kapjuk, amit a date pipe is mutat.
    const d = new Date(b.utolso_tetel_datum); d.setHours(0, 0, 0, 0);
    const ma = new Date(); ma.setHours(0, 0, 0, 0);
    let n = 0;
    while (d < ma) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) n++; }
    return n;
  }
  adatElakadt(b: any): boolean { const n = this.adatElmaradas(b); return n != null && n >= 3; }

  // ----- meghatalmazás (mandate) -----
  // Bank összekötése: vagy itt helyben megnyitjuk a banki meghatalmazó oldalt, vagy az ügyfél
  // emailjére küldjük a linket, hogy ő végezze el. Egy meghatalmazás több számlát is hozhat.
  async bankOsszekot(b?: any) {
    const a = await this.alert.create({
      header: 'Bank összekötése',
      message: 'Hogyan szeretnéd elvégezni a banki meghatalmazást? Egy meghatalmazás a bank összes számláját behozhatja (mindegyik külön főkönyvi számra állítható).',
      buttons: [
        { text: 'Mégse', role: 'cancel' },
        { text: 'Email az ügyfélnek', handler: () => this.mandateEmail(b) },
        { text: 'Megnyitom most', handler: () => this.mandateMegnyit(b) },
      ],
    });
    await a.present();
  }
  private async mandateMegnyit(b?: any) {
    try {
      const r: any = await this.post(`/${this.aktiv.ugyfelId}/mandate`, { iban: b?.iban });
      if (r?.url) {
        window.open(r.url, '_blank');
        this.mandateVar = true;   // visszatéréskor (ablak-fókusz) automatikusan ellenőrzünk
        this.ok('Meghatalmazó oldal megnyitva — a bank engedélyezése után térj vissza ide.');
      } else this.ok('Meghatalmazás elindítva.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült elindítani a meghatalmazást.'); }
  }

  // Visszatéréskor (a consent fülről) automatikus ellenőrzés – option 1 (visszakérdezés a relén át).
  @HostListener('window:focus')
  onFocus() { if (this.mandateVar && !this.ellenorzFut) this.mandateEllenoriz(true); }

  async mandateEllenoriz(auto = false) {
    if (!this.aktiv.ugyfelId) return;
    this.ellenorzFut = true;
    try {
      const r: any = await this.post(`/${this.aktiv.ugyfelId}/mandate-ellenoriz`, {});
      if (r?.kesz) { this.mandateVar = false; await this.betolt(); this.ok(`Bank összekötve: ${r.szamlak} számla aktiválva.`); }
      else if (!auto) this.ok('Még nem érkezett vissza a meghatalmazás. Fejezd be a banki engedélyezést, majd ellenőrizd újra.');
    } catch (e: any) { if (!auto) this.hiba(e?.error?.error || 'Nem sikerült ellenőrizni a kapcsolatot.'); }
    finally { this.ellenorzFut = false; }
  }
  private async mandateEmail(b?: any) {
    try { const r: any = await this.post(`/${this.aktiv.ugyfelId}/mandate`, { iban: b?.iban, eredmeny: 'email' }); await this.betolt(); this.ok(`Email kiküldve az ügyfélnek${r?.email ? ' (' + r.email + ')' : ''}.`); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült emailt küldeni.'); }
  }
  async emailUgyfelnek(b: any) { this.mandateEmail(b); }

  // ----- szinkron -----
  async szinkron(b?: any) {
    this.szinkronFut = b?.id || 'mind';
    try {
      const r: any = await this.post(`/${this.aktiv.ugyfelId}/szinkron`, {
        bank_id: b?.id, tol: this.szinkronTartomany.tol || undefined, ig: this.szinkronTartomany.ig || undefined,
      });
      await this.betolt();
      // Az „elakadt adatfolyam" a fontosabb üzenet: 0 új tranzakció lehet teljesen normális is
      // (nincs forgalom), de ha az adatszolgáltatónál napok óta nincs ÚJABB tétel, az hiba.
      const fig: string[] = r?.figyelmeztetesek || [];
      if (fig.length) { this.figyelem(`${r?.uj ? r.uj + ' új tranzakció. ' : ''}${fig.join(' ')}`); return; }
      if ((r?.uj ?? 0) === 0) {
        // diagnosztika: ha 0 az új, mutassuk meg, meddig van egyáltalán adat és hány tételt adott a relé
        const d = (r?.reszletek || []).map((x: any) =>
          `${x.iban?.slice(-8) || '?'}: ${x.nyers ?? '?'} tétel, adat eddig: ${x.utolso_tetel || '—'}`).join(' | ');
        this.ok(`Szinkron kész: 0 új tranzakció. ${d || 'A relé nem adott adatot.'}`);
      } else this.ok(`Szinkron kész: ${r.uj} új tranzakció.`);
    } catch (e: any) { this.hiba(e?.error?.error || 'A szinkron nem sikerült.'); }
    finally { this.szinkronFut = null; }
  }

  // ----- kontírozás (Adriana V2 – Fázis 2) -----
  // 1) Javaslatkérés: a motor kiszámol, de NEM ír. A javaslatokat a Kontír-javaslat fülön mutatjuk,
  // ahol soronként módosítható / kivehető, majd a „Mehet" gomb véglegesít.
  // „RLB segéd mód": ha be van kapcsolva, a kipontozáshoz MINDEN számla felajánlható,
  // nem csak a már lekönyveltek (egyszeres/RLB könyvelésnél a számla nem kettős tételként
  // jelenik meg, ezért az alap szűrő mindent kizárna). Ügyfél-szintű, perzisztens beállítás.
  rlbSeged = false;

  async rlbSegedBetolt() {
    try {
      const r: any = await this.get(`/${this.aktiv.ugyfelId}/rlb-seged`);
      this.rlbSeged = !!r?.rlb_seged;
    } catch { this.rlbSeged = false; }
  }

  async rlbSegedValt(be: boolean) {
    this.rlbSeged = !!be;
    this.javaslatElavult = true;   // más számlák jöhetnek a párosításhoz → a javaslat újrakérendő
    try {
      await this.put(`/${this.aktiv.ugyfelId}/rlb-seged`, { rlb_seged: this.rlbSeged });
      this.ok(this.rlbSeged
        ? 'RLB segéd mód bekapcsolva – minden számla kontírozható.'
        : 'RLB segéd mód kikapcsolva – csak a lekönyvelt számlák.');
    } catch (e: any) { this.hiba(e?.error?.error || 'A kapcsoló mentése nem sikerült.'); }
  }

  // Küldjön-e az RLB export önálló árfolyam-bizonylatot (XF/XT)? Kikapcsolva a banki sor
  // hivatkozásos formában megy (devizanem + árfolyam + deviza-összeg), és a különbözetet
  // az RLB vezeti le a számla könyv szerinti értékéből – így nem duplikálódik.
  rlbArfolyam = true;

  async rlbArfolyamBetolt() {
    try {
      const r: any = await this.get(`/${this.aktiv.ugyfelId}/rlb-arfolyam`);
      this.rlbArfolyam = r?.rlb_arfolyam !== false;
    } catch { this.rlbArfolyam = true; }
  }

  async rlbArfolyamValt(be: boolean) {
    this.rlbArfolyam = !!be;
    try {
      await this.put(`/${this.aktiv.ugyfelId}/rlb-arfolyam`, { rlb_arfolyam: this.rlbArfolyam });
      this.ok(this.rlbArfolyam
        ? 'Az árfolyam-különbözetet MI küldjük (önálló XF/XT bizonylat).'
        : 'Az árfolyam-különbözetet az RLB számolja – nem küldünk XF/XT bizonylatot.');
    } catch (e: any) { this.hiba(e?.error?.error || 'A kapcsoló mentése nem sikerült.'); }
  }

  //  A javaslat-fülön az RLB segéd mód más számlákat kínál fel → a váltás után újrakérjük
  //  (a fülön addig végzett, még nem véglegesített módosítások ilyenkor elvesznek).
  async javaslatRlbSegedValt(be: boolean) {
    await this.rlbSegedValt(be);
    this.kontirJavaslat();
  }

  async kontirJavaslat() {
    const ujra = this.javaslatUjra;
    this.kontirFut = true;
    this.javaslatElavult = false;
    try {
      const r: any = await this.post(`/${this.aktiv.ugyfelId}/kontir-javaslat`, { ujra });
      if (r && r.rlb_seged !== undefined) this.rlbSeged = !!r.rlb_seged;
      this.javaslatok = (r?.javaslatok || []).map((j: any) => {
        // erős előválasztás → kezdő allokáció (1 számlára, a hátralékig).
        // FONTOS: ugyanazzal a pénznem-tudatos logikával, mint a kézi választás –
        // különben a devizás számla forint-kerethez mérődik („14,5 / 32 058 Ft").
        const sel = j.szamla_id ? (j.szamlak || []).find((s: any) => s.id === j.szamla_id) : null;
        /*  BONTOTT JAVASLAT: ha az utalás több számlát fedez (a kiszolgáló pontos összeg-egyezést
         *  talált kettő-három számlára), azt kezdjük kitöltve – a felület „bontott (N db)"-ként
         *  mutatja, és a szerkesztőben módosítható. */
        const bontas = (j.bontas || []).map((x: any) => {
          const sz = (j.szamlak || []).find((s: any) => s.id === x.szamla_id);
          return sz ? this.ujParositas(j, sz, Number(x.osszeg)) : null;
        }).filter(Boolean);
        const parositasok = bontas.length ? bontas : (sel ? [this.ujParositas(j, sel)] : []);
        return { ...j, kivalaszt: true, tanul: false, parositasok, partner_felulir: j.partner_felulir || '',
          deviza_nem: j.deviza_nem && j.deviza_nem !== 'HUF' ? j.deviza_nem : '',
          devizaSzerk: !!j.deviza_kezi, devizaModositva: false };
      });
      this.partnerNevekBetolt();
      //  Üres listánál nincs üzenet: a fül maga mondja ki („Nincs új tétel…"). A dátumszűrő
      //  újratöltéskor is megmarad (a Mehet úgyis csak a látható sorokra hat).
    } catch (e: any) { this.hiba(e?.error?.error || 'A javaslatkérés nem sikerült.'); }
    finally { this.kontirFut = false; }
  }
  javaslatForrasCimke(f: string) {
    return ({ szabaly: 'szabály', tanult: 'tanult', atvezetes: 'átvezetés', tartalek: 'tartalék' } as any)[f] || f;
  }
  javaslatKivalasztva() { return this.javaslatokSzurve.filter((j) => j.kivalaszt).length; }
  // Devizás számlánál a hátralékot a SAJÁT pénznemében és MNB-forintértékén is mutatjuk
  // (a forintérték a számla keltének középárfolyamával – ugyanazzal, amivel az
  // árfolyamkülönbözet is számol, így a két szám egymással konzisztens).
  szamlaCimke(s: any) {
    const dev = s.deviza && s.deviza !== 'HUF';
    const osszeg = dev
      ? `${this.fmt(s.hatralek)} ${s.deviza}${s.hatralek_huf != null ? ' ≈ ' + this.fmt(s.hatralek_huf) + ' Ft' : ''}`
      : `${this.fmt(s.hatralek)} Ft`;
    return `${s.bizonylatszam || '?'} · ${osszeg}${s.forras === 'osa' ? ' [OSA]' : ''}${s.okok?.length ? ' (' + s.okok.join(', ') + ')' : ''}`;
  }

  // A párosítás kerete és pénzneme: devizás párosításnál a banktétel deviza-összege,
  // egyébként a forint-összeg (korábban a kettőt keverte a felirat).
  // Devizás a párosítás, ha a SZÁMLA devizás – akkor is, ha a banktétel forintos.
  parosDevizas(j: any) {
    const p = (j?.parositasok || [])[0];
    return !!(p && p.deviza && p.deviza !== 'HUF');
  }
  // A keret annak a pénznemnek megfelelő: azonos devizánál a banktétel deviza-összege,
  // forintos banktételnél a forint-összeg (ilyenkor a párosított oldalt a HUF-értékkel
  // hasonlítjuk, lásd parositasOsszegHuf).
  parosAzonosDeviza(j: any) {
    const p = (j?.parositasok || [])[0];
    return !!(p && p.deviza && p.deviza !== 'HUF' && j?.deviza_nem === p.deviza);
  }
  parositasok0Deviza(j: any) { return (j?.parositasok || [])[0]?.deviza || ''; }
  parosKeret(j: any) { return this.parosAzonosDeviza(j) ? this.abs(j.deviza_osszeg) : this.abs(j.osszeg); }
  parosPenznem(j: any) { return this.parosAzonosDeviza(j) ? j.deviza_nem : 'Ft'; }
  // Amit a keret ellen mérünk: azonos devizánál a deviza-összeg, különben a forintérték.
  parosMertOsszeg(j: any) {
    if (this.parosAzonosDeviza(j)) return this.parositasOsszeg(j);
    const huf = this.parositasOsszegHuf(j);
    return huf != null ? huf : this.parositasOsszeg(j);
  }

  // Árfolyamkülönbözet-előnézet a JELENLEGI párosításra. A javaslat csak az automatikusan
  // előválasztott párra számolt ilyet; kézi választás/bontás után innen kérjük el, hogy a
  // különbözet (és a 9762/8762 főkönyvi szám) még véglegesítés ELŐTT látszódjon.
  async arfolyamElonezet(j: any) {
    // Akkor is kell előnézet, ha a BANKTÉTEL forintos, de a párosított SZÁMLA devizás
    // (külföldi vevő EUR-számláját a bank forintra váltva írja jóvá).
    const vanDeviza = (j?.parositasok || []).some((p: any) => p.deviza && p.deviza !== 'HUF');
    if (!j || !(j.parositasok || []).length || !vanDeviza) { if (j) j.arfolyam = null; return; }
    try {
      const r: any = await this.post(`/${this.aktiv.ugyfelId}/arfolyam-elonezet`, {
        tetel_id: j.id,
        parositasok: (j.parositasok || []).map((p: any) => ({ szamla_id: p.szamla_id, osszeg: p.osszeg, osszeg_huf: p.osszeg_huf })),
        ...(j.devizaModositva ? { deviza_osszeg: j.deviza_osszeg, deviza_nem: j.deviza_nem } : {}),
      });
      j.arfolyam = r && r.kulonbozet ? r : null;
    } catch { j.arfolyam = null; }
  }
  // számla-párosítás csak vevő/szállító tételnél értelmezhető
  parosithato(tipus: string) { return tipus === 'vevo' || tipus === 'szallito'; }
  abs(n: any) { return Math.abs(Number(n) || 0); }
  parositasOsszeg(j: any) { return (j.parositasok || []).reduce((s: number, a: any) => s + (Number(a.osszeg) || 0), 0); }
  // gyors 1:1 választás a soron belüli legördülőből (a bontás külön szerkesztőben)
  egyszeruSzamlaId(j: any) { const p = j.parositasok || []; return p.length === 1 ? p[0].szamla_id : (p.length > 1 ? 'TOBB' : null); }
  // Egy párosítás-sor felépítése a banktételhez és a kiválasztott számlához.
  // Devizás számla + azonos pénznemű banktétel → a számla PÉNZNEMÉBEN allokálunk (a
  // véglegesítő is így várja); egyébként forintban. Korábban a forint-összeg és a
  // deviza-hátralék keveredett a min()-ben, ezért látszott „14,5 / 32 058 Ft".
  private ujParositas(j: any, s: any, osszeg?: number, osszegHuf?: number) {
    const szlaDev = !!(s.deviza && s.deviza !== 'HUF');
    const azonosDev = szlaDev && j.deviza_nem === s.deviza;
    // Az allokáció mindig a SZÁMLA pénznemében megy (a véglegesítő így várja):
    // azonos pénznemnél a banktétel deviza-összege a keret, forintos banktételnél a
    // számla hátraléka (a forint-oldalt az `osszeg_huf` viszi).
    const keret = azonosDev ? this.abs(j.deviza_osszeg) : (szlaDev ? Number(s.hatralek) : this.abs(j.osszeg));
    const ossz = osszeg != null ? osszeg : Math.min(keret, Number(s.hatralek));
    // Forintérték: azonos pénznemnél a tranzakció HUF-jának arányos része, egyébként
    // a megadott/könyv szerinti (MNB) forint.
    let huf = osszegHuf;
    if (huf == null && szlaDev) {
      if (azonosDev && this.abs(j.deviza_osszeg) > 0) huf = this.abs(j.osszeg) * (ossz / this.abs(j.deviza_osszeg));
      else if (s.mnb) huf = ossz * Number(s.mnb);
    }
    return {
      szamla_id: s.id, bizonylatszam: s.bizonylatszam, partner_nev: s.partner_nev,
      hatralek: s.hatralek, deviza: s.deviza || 'HUF', mnb: s.mnb ?? null,
      osszeg: ossz, osszeg_huf: huf != null ? Math.round(huf) : undefined,
    };
  }

  egyszeruValaszt(j: any, id: any) {
    if (id === 'TOBB') return;                     // a 'bontott' opció nem cél, csak jelző
    if (!id) { j.parositasok = []; j.arfolyam = null; return; }
    const s = (j.szamlak || []).find((x: any) => x.id === id);
    if (!s) return;
    j.parositasok = [this.ujParositas(j, s)];
    this.arfolyamElonezet(j);
  }

  // A párosított összeg forint-értéke (devizásnál a számla MNB-árfolyamával = könyv
  // szerinti érték); ha nincs árfolyam, null → a felület nem mutat becslést.
  parositasOsszegHuf(j: any) {
    if (!this.parosDevizas(j)) return null;
    let ossz = 0;
    for (const p of (j.parositasok || [])) {
      if (Number(p.osszeg_huf) > 0) { ossz += Number(p.osszeg_huf); continue; }
      const arf = Number(p.mnb) || 0;
      if (!arf) return null;
      ossz += (Number(p.osszeg) || 0) * arf;
    }
    return Math.round(ossz);
  }

  // ----- bontásos kipontozó (egy tranzakció több számlára) -----
  async bontasNyit(j: any) {
    this.bontasTr = j; this.bontasFut = true; this.bontasSorok = [];
    try {
      const irany = (Number(j.osszeg) || 0) >= 0 ? 'be' : 'ki';
      // `tetel_id`: a backend ehhez a banktételhez pontozza a jelölteket, így az UTÓLAG
      // beemelt számla is megkapja a jeleket (bizonylatszám/összeg/partner/dátum).
      const nyitott: any[] = await this.get(`/${this.aktiv.ugyfelId}/nyitott-szamlak?irany=${irany}&tetel_id=${encodeURIComponent(j.id)}`);
      // A meglévő párosítások a SZÁMLA pénznemében vannak – a szerkesztő forintban
      // dolgozik, ezért forintra váltva töltjük be őket.
      const kivalasztva = new Map<string, number>((j.parositasok || []).map((a: any) =>
        [a.szamla_id, Number(a.osszeg_huf) > 0 ? Number(a.osszeg_huf) : Number(a.osszeg)]));
      const pontMap = new Map<string, any>((j.szamlak || []).map((s: any) => [s.id, s]));
      this.bontasSorok = nyitott.map((s) => ({
        szamla: s,
        include: kivalasztva.has(s.id),
        // FORINTBAN: a keret és a hátralék is forintban értendő (korábban a deviza-hátralék
        // került ide, ezért látszott „14,5 Ft" az Ebből most mezőben).
        osszeg: kivalasztva.has(s.id) ? kivalasztva.get(s.id) : Math.round(Math.min(this.bontasKeret(s), this.bontasHatralekHuf(s))),
        // A jeleket elsősorban a MOSTANI pontozásból vesszük (a backend a tetel_id alapján
        // számolta), tartalékként a javaslatban kapott találatokból.
        okok: (s.okok && s.okok.length ? s.okok : pontMap.get(s.id)?.okok) || [],
        pont: Number(s.pont) || pontMap.get(s.id)?.pont || 0,
      })).sort((a, b) => (b.pont - a.pont) || (b.okok.length - a.okok.length)
        || ((new Date(b.szamla.kelt).getTime() || 0) - (new Date(a.szamla.kelt).getTime() || 0)));
    } catch { this.hiba('Nem sikerült betölteni a nyitott számlákat.'); }
    finally { this.bontasFut = false; }
  }

  // ── A bontás VÉGIG FORINTBAN történik: a bankban forint mozgott (a bank saját
  // árfolyamán), és a könyvelő is forintban gondolkodik. A devizás számlákra mentéskor
  // váltunk vissza a számla pénznemére a tranzakció TÉNYLEGES (banki) árfolyamával –
  // így a részösszegek pontosan kiadják a tétel deviza-összegét, és a számla
  // kiegyenlítettsége a saját pénznemében marad helyes.
  // A SORé a döntő: devizás a számla? (Akkor is, ha a banktétel forintos – ilyenkor a
  // visszaváltás MNB-vel megy. Korábban ez a feltétel a banktétel devizáját is kérte,
  // ezért forintos jóváírásnál el sem látszott, hogy a számla EUR-os.)
  bontasSorDevizas(s: any) { return !!(s?.deviza && s.deviza !== 'HUF'); }
  // Azonos pénznemű-e a banktétellel (ekkor a banki árfolyammal váltunk).
  bontasDevizasSor(s: any) {
    const tr = this.bontasTr;
    return !!(tr?.deviza_nem && tr.deviza_nem !== 'HUF' && s?.deviza && s.deviza === tr.deviza_nem);
  }
  bontasVanDeviza() { return !!(this.bontasTr?.deviza_nem && this.bontasTr.deviza_nem !== 'HUF'); }

  // A banktétel tényleges árfolyama (HUF / deviza) – ezzel váltunk oda-vissza.
  // Forintos banktételnél nincs ilyen (a bank nem devizában könyvelte) → MNB a tartalék.
  bontasBankArfolyam() {
    const dev = this.abs(this.bontasTr?.deviza_osszeg);
    return dev > 0 ? this.abs(this.bontasTr?.osszeg) / dev : null;
  }
  // A visszaváltáshoz használt árfolyam egy sorra: banki, ha van; különben a számla MNB-je.
  bontasSorArfolyam(s: any) {
    if (!(s?.deviza && s.deviza !== 'HUF')) return null;
    return (this.bontasDevizasSor(s) ? this.bontasBankArfolyam() : null) || (Number(s.mnb) || null);
  }
  // Egy sor hátraléka FORINTBAN. Devizás számlánál a banktétel TÉNYLEGES árfolyamával
  // számolunk (nem MNB-vel), mert a mentés is ezzel vált vissza – így a teljes hátralék
  // beírása pontosan lezárja a számlát. Ha nincs banki árfolyam (pl. HUF-tranzakció
  // devizás számlához), az MNB-érték a tartalék.
  bontasHatralekHuf(s: any) {
    if (!(s?.deviza && s.deviza !== 'HUF')) return Number(s?.hatralek) || 0;
    const arf = this.bontasSorArfolyam(s);
    if (arf) return Math.round(Number(s.hatralek) * arf);
    if (s.hatralek_huf != null) return Number(s.hatralek_huf);
    return Number(s.hatralek);
  }
  // A forintban megadott részösszeg a számla pénznemében (mentéshez), a hátralékra vágva.
  // ugyanaz, publikusan – a sablon mutatja vele, mennyi lesz devizában
  bontasHufDevizaraNezet(s: any, huf: any) { return this.bontasHufDevizara(s, Number(huf) || 0); }
  private bontasHufDevizara(s: any, huf: number) {
    const arf = this.bontasSorArfolyam(s);
    if (!arf) return huf;                                   // forintos számla: marad forint
    return Math.min(Math.round((huf / arf) * 100) / 100, Number(s.hatralek));
  }
  private bontasKeret(_s: any) { return this.abs(this.bontasTr?.osszeg); }   // egyetlen keret: a forint-összeg

  bontasOsszeg() { return this.bontasSorok.filter((r) => r.include).reduce((s, r) => s + (Number(r.osszeg) || 0), 0); }
  bontasMarad() { return this.abs(this.bontasTr?.osszeg) - this.bontasOsszeg(); }

  // Van-e devizás számla a kijelöltek közt? Ilyenkor a NEGATÍV maradék NEM hiba: a
  // devizás számla könyv szerinti (MNB) forintértéke és a ténylegesen befolyt/kifizetett
  // forint eltérhet – épp ez az eltérés lesz az árfolyamnyereség/-veszteség (9762/8762).
  bontasVanDevizasKijelolt() {
    return this.bontasSorok.some((r) => r.include && this.bontasSorDevizas(r.szamla));
  }
  // Blokkoló túllépés: csak tisztán forintos párosításnál (ott a többlet valódi hiba).
  bontasTullepes() { return this.bontasMarad() < -0.5 && !this.bontasVanDevizasKijelolt(); }
  bontasAuto() {     // mohó kitöltés a forint-hátralékokból, amíg a tranzakció el nem fogy
    let marad = this.abs(this.bontasTr?.osszeg);
    this.bontasSorok.forEach((r) => (r.include = false));
    for (const r of this.bontasSorok) {
      if (marad <= 0.5) break;
      const teljes = this.bontasHatralekHuf(r.szamla);
      // Devizás számlánál a TELJES hátralékot bejelöljük akkor is, ha a forint-keretbe már
      // épp nem fér bele: a különbség árfolyam-eredmény lesz (mentéskor a bank forintját
      // arányosan osztjuk szét). Forintos számlánál marad a keretre vágás.
      const ad = this.bontasSorDevizas(r.szamla) ? teljes : Math.min(teljes, marad);
      if (ad > 0.5) { r.include = true; r.osszeg = Math.round(ad); marad -= ad; }
    }
  }
  bontasKesz() {
    const j = this.bontasTr; if (!j) return;
    // A szerkesztőben FORINTBAN adtuk meg a részösszegeket → a devizás számlákra a
    // banktétel tényleges árfolyamával váltjuk vissza a számla pénznemére.
    const sorok = this.bontasSorok.filter((r) => r.include && Number(r.osszeg) > 0);
    // TÚLKIOSZTÁS devizás számláknál: a beírt forint összege több, mint amennyi a bankban
    // ténylegesen mozgott (mert a sorok a KÖNYV SZERINTI értéken állnak). Ez azt jelenti,
    // hogy a tétel ezeket a számlákat egyenlíti ki – a bank forintját tehát ARÁNYOSAN
    // osztjuk szét rájuk, a különbség pedig árfolyamnyereség/-veszteség lesz.
    // (A számla pénznemében vett összeg NEM változik: a számla teljesen kiegyenlítődik.)
    const hufOssz = sorok.reduce((s, r) => s + (Number(r.osszeg) || 0), 0);
    const bank = this.abs(j.osszeg);
    const vanDeviza = sorok.some((r) => this.bontasSorDevizas(r.szamla));
    const skala = (vanDeviza && hufOssz > bank + 0.5 && hufOssz > 0) ? bank / hufOssz : 1;

    j.parositasok = sorok.map((r) => this.ujParositas(
      j, r.szamla,
      this.bontasHufDevizara(r.szamla, Number(r.osszeg)),   // a számla pénznemében (skálázatlan)
      Math.round(Number(r.osszeg) * skala),                 // a bankból ténylegesen ráeső forint
    ));
    this.bontasTr = null; this.bontasSorok = [];
    this.arfolyamElonezet(j);     // bontás után is legyen árfolyamkülönbözet-előnézet
  }
  javaslatMindKivalaszt(v: boolean) { this.javaslatokSzurve.forEach((j) => (j.kivalaszt = v)); }
  // 2) Véglegesítés: csak a kijelölt (és nem üres ellenszámlájú) sorok mentődnek.
  async javaslatMehet() {
    const valasztott = this.javaslatokSzurve.filter((j) => j.kivalaszt && j.fokonyvi_szam);
    if (!valasztott.length) { this.hiba('Nincs kijelölt, kitöltött ellenszámlájú tétel.'); return; }
    this.veglegesitFut = true;
    try {
      const r: any = await this.post(`/${this.aktiv.ugyfelId}/kontir-veglegesit`, {
        tetelek: valasztott.map((j) => ({ id: j.id, tipus: j.tipus, fokonyvi_szam: j.fokonyvi_szam, parositasok: (j.parositasok || []).map((a: any) => ({ szamla_id: a.szamla_id, osszeg: a.osszeg, osszeg_huf: a.osszeg_huf })), tanul: !!j.tanul,
          partner_felulir: String(j.partner_felulir || '').trim(),
          //  A deviza csak akkor megy, ha a sorban átírták – a közleményből olvasottat nem tesszük kézivé.
          ...(j.devizaModositva ? { deviza_osszeg: j.deviza_osszeg ?? '', deviza_nem: j.deviza_nem || '' } : {}) })),
      });
      //  A fül a maradék tételekkel frissül (a véglegesítettek kikerülnek a javaslatból).
      this.javaslatok = []; await Promise.all([this.tranzakcioBetolt(), this.kontirJavaslat()]);
      const kihagyva: any[] = r?.kihagyva || [];
      const kesz = `Kész: ${r?.mentve ?? 0} kontírozva${r?.parositott ? ', ' + r.parositott + ' számlához párosítva' : ''}${r?.tanult ? ', ' + r.tanult + ' szabály tanulva' : ''}.`;
      if (kihagyva.length) {
        //  A már párosított / könyvelt tételt a mentés nem írja át – ezt ki kell mondani,
        //  különben úgy tűnik, a másik számla kiválasztása megtörtént.
        const lista = kihagyva.slice(0, 5).map((x) => `${x.datum} ${x.partner_nev || ''} ${this.fmt(x.osszeg)} Ft (${x.statusz === 'konyvelt' ? 'könyvelt' : 'párosított'})`).join('\n');
        alert(`${kesz}\n\n${kihagyva.length} tételt NEM módosítottam, mert már párosított vagy könyvelt:\n${lista}${kihagyva.length > 5 ? '\n…' : ''}\n\nMásik számlára váltáshoz előbb vond vissza a tétel kontírját (a Számlatörténet fülön, a sor végén), utána kontírozd újra.`);
      } else {
        this.ok(kesz);
      }
    } catch (e: any) { this.hiba(e?.error?.error || 'A véglegesítés nem sikerült.'); }
    finally { this.veglegesitFut = false; }
  }
  // FONTOS: minden mezőt át kell venni a tranzakcióból, amit a mentés vissza is küld – különben
  // a kihagyott mezőket (számla főkönyvi száma, fordított ÁFA) a mentés NULL-ra írná.
  trSzerkeszt(t: any) {
    this.szerkesztTr = { id: t.id, tipus: t.tipus || '', fokonyvi_szam: t.fokonyvi_szam || '',
      szamla_fokonyvi_szam: t.szamla_fokonyvi_szam || '',
      forditott_afa: !!Number(t.forditott_afa), forditott_afa_kulcs: Number(t.forditott_afa_kulcs) || 27,
      partner_nev: t.partner_nev, partner_felulir: t.partner_felulir || '', osszeg: t.osszeg, tanul: true,
      deviza_osszeg: t.deviza_nem && t.deviza_nem !== 'HUF' ? t.deviza_osszeg : '',
      deviza_nem: t.deviza_nem && t.deviza_nem !== 'HUF' ? t.deviza_nem : 'EUR',
      deviza_kezi: Number(t.deviza_kezi) === 1,
      devizaEredeti: `${t.deviza_nem && t.deviza_nem !== 'HUF' ? t.deviza_osszeg : ''}|${t.deviza_nem && t.deviza_nem !== 'HUF' ? t.deviza_nem : 'EUR'}` };
    this.partnerNevekBetolt();
  }

  // Kontír visszavonása: a tétel visszaáll „új"-ra, ÉS a párosítással jóváírt összegek
  // visszakerülnek a számlákra (különben kifizetettként ragadnának bent). Könyvelt
  // tételnél külön rákérdezünk, mert ott a kettős bizonylat már létrejött.
  kontirVisszavonFut: string | null = null;
  tomegesVisszavonFut = false;

  // TÖMEGES visszavonás a JELENLEG SZŰRT listára (bankszámla + státusz + dátumtartomány).
  // Előbb megszámoltatjuk a backenddel, hogy pontos darabszámmal tudjunk megerősítést kérni.
  async kontirVisszavonTomeges() {
    const szuro: any = { bank_id: this.szuro.bank_id || undefined, statusz: this.szuro.statusz || undefined,
      tol: this.szuro.tol || undefined, ig: this.szuro.ig || undefined };
    this.tomegesVisszavonFut = true;
    try {
      const elo: any = await this.post(`/${this.aktiv.ugyfelId}/kontir-visszavon-tomeges`, { ...szuro, csak_szamol: true });
      const db = Number(elo?.erintett || 0);
      const konyvelt = Number(elo?.kihagyott_konyvelt || 0);
      if (!db && !konyvelt) { this.ok('Nincs visszavonható kontír a szűrt tartományban.'); return; }

      const idoszak = (this.szuro.tol || this.szuro.ig)
        ? `\nIdőszak: ${this.szuro.tol || '…'} – ${this.szuro.ig || '…'}` : '\n(a teljes lista)';
      let uzenet = `${db} tétel kontírja és párosítása visszavonásra kerül.${idoszak}\n\nA párosított számlák kiegyenlítése visszagörgetődik.`;
      if (konyvelt) uzenet += `\n\n${konyvelt} MÁR KÖNYVELT tételt kihagyok (azokat külön, egyesével lehet erőltetve visszavonni).`;
      if (!db || !confirm(uzenet)) return;

      const r: any = await this.post(`/${this.aktiv.ugyfelId}/kontir-visszavon-tomeges`, szuro);
      this.ok(`${r?.visszavont || 0} tétel visszavonva`
        + (r?.visszavont_szamla ? `, ${r.visszavont_szamla} számla-kiegyenlítés visszagörgetve` : '')
        + (r?.kihagyott_konyvelt ? `. ${r.kihagyott_konyvelt} könyvelt tétel kihagyva.` : '.'));
      this.javaslatElavult = true; await this.tranzakcioBetolt();
    } catch (e: any) { this.hiba(e?.error?.error || 'A tömeges visszavonás nem sikerült.'); }
    finally { this.tomegesVisszavonFut = false; }
  }
  async kontirVisszavon(t: any, force = false) {
    const mit = t.parositas ? 'a kontírt ÉS a számla-párosítást' : 'a kontírt';
    if (!force && !confirm(`Biztosan visszavonod ${mit}?\n\n${t.partner_nev || ''} · ${this.fmt(t.osszeg)} Ft\n\nA tétel újra kontírozható lesz.`)) return;
    this.kontirVisszavonFut = t.id;
    try {
      const r: any = await this.post(`/${this.aktiv.ugyfelId}/kontir-visszavon/${t.id}${force ? '?force=1' : ''}`, {});
      if (r && r.ok === false && r.konyvelt) {
        this.kontirVisszavonFut = null;
        if (confirm(r.egyszeres ? `${r.uzenet}\n\nMégis visszavonod?`
          : `${r.uzenet}\n\nMégis visszavonod? (A már elkészült kettős bizonylat MEGMARAD, csak a kapcsolat szűnik meg – azt külön kell törölnöd a Kettős modulban.)`)) {
          return this.kontirVisszavon(t, true);
        }
        return;
      }
      this.ok('Kontír visszavonva.' + (r?.visszavont_szamla ? ` ${r.visszavont_szamla} számla kiegyenlítése visszagörgetve.` : ''));
      this.javaslatElavult = true; await this.tranzakcioBetolt();
    } catch (e: any) { this.hiba(e?.error?.error || 'A visszavonás nem sikerült.'); }
    finally { this.kontirVisszavonFut = null; }
  }
  async trMent() {
    const s = this.szerkesztTr; if (!s) return;
    try {
      await this.put(`/${this.aktiv.ugyfelId}/tranzakcio/${s.id}`, { tipus: s.tipus, fokonyvi_szam: s.fokonyvi_szam, szamla_fokonyvi_szam: s.szamla_fokonyvi_szam || null,
        forditott_afa: !!s.forditott_afa, forditott_afa_kulcs: Number(s.forditott_afa_kulcs) || 27, tanul: !!s.tanul,
        partner_felulir: String(s.partner_felulir || '').trim(),
        //  A deviza csak akkor megy, ha változott – a közleményből olvasottat nem tesszük kézivé.
        ...(`${s.deviza_osszeg ?? ''}|${s.deviza_nem || ''}` !== s.devizaEredeti ? { deviza_osszeg: s.deviza_osszeg ?? '', deviza_nem: s.deviza_nem || '' } : {}) });
      this.szerkesztTr = null; this.javaslatElavult = true; await this.tranzakcioBetolt(); this.ok(s.tanul ? 'Mentve és megtanulva a partnerre.' : 'Mentve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }

  // ----- könyvelés (Fázis 3) -----
  konyvelFut = false;
  async konyvel() {
    const a = await this.alert.create({
      header: 'Könyvelés', message: this.egyszeres
        ? 'A kontírozott/párosított tételek könyvelése a naplófőkönyvbe, a Bank pénztárra. A már lekönyvelt számla nem kerül be újra, a banki tétel csak hozzá kötődik. Folytatod?'
        : 'A kontírozott/párosított tételek vegyes kettős bizonylatként könyvelése (deviza tételnél az árfolyamkülönbözettel együtt). Folytatod?',
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Könyvelés', role: 'ok' }],
    });
    await a.present(); const { role } = await a.onDidDismiss(); if (role !== 'ok') return;
    this.konyvelFut = true;
    try {
      const r: any = await this.post(`/${this.aktiv.ugyfelId}/konyvel`, {});
      this.javaslatElavult = true; await this.tranzakcioBetolt();
      const hibak: any[] = r?.hibak || [];
      const h = hibak.length;
      //  Az okot is kiírjuk (pl. visszavonás után bent maradt bizonylat) – a puszta
      //  darabszámból nem derül ki, mit kell rendbe tenni.
      const okok = [...new Set(hibak.map((x) => x.hiba))].slice(0, 3).join('; ');
      const kotve = r?.osszekotve ? ` (ebből ${r.osszekotve} a már lekönyvelt számlához kötve)` : '';
      if (r?.konyvelt) this.ok(`Könyvelve: ${r.konyvelt} ${r?.mod === 'egyszeres' ? 'tétel a naplófőkönyvbe' : 'bizonylat'}${kotve}${h ? `, ${h} kihagyva: ${okok}` : ''}.`);
      else this.hiba(h ? `Nincs könyvelve – ${h} tétel kihagyva: ${okok}` : 'Nincs könyvelhető tétel.');
    } catch (e: any) { this.hiba(e?.error?.error || 'A könyvelés nem sikerült.'); }
    finally { this.konyvelFut = false; }
  }

  // A kontírozott/könyvelt banki tételek letöltése az RLB könyvelőprogram "többsoros"
  // import-formátumába (BF/BT, ANSI/Windows-1250). A választott bank + időszak szerint.
  rlbFut = false;
  rlbModal = false;
  // Az exportra külön, a felhasználó által megadható időszak (alapból a szinkron-tartomány). ÉÉÉÉ-HH-NN.
  rlbTartomany = { tol: '', ig: '' };
  // A gomb ezt nyitja: itt lehet megadni, milyen időszakra exportáljon (alapból a fent beállított tartomány).
  // Az RLB importja a devizás számlák KIEGYENLÍTÉSÉT nem kezeli („A devizás kiegyenlítést
  // nem kezeli a program." – RLB dokumentáció, Automatikus könyvelés csv-ből), ezért ezek
  // kimaradnak a CSV-ből, és itt soroljuk fel a kézi rögzítéshez szükséges adatokkal.
  rlbDevizasok: any[] = [];
  // Mit tegyen a devizás kiegyenlítésekkel: 'kihagy' (az RLB kézi devizás kiegyenlítőjével
  // rögzíted – az zárja a folyószámlát és könyveli az árfolyamot is), vagy 'forint'
  // (forintosítva, hivatkozás nélkül bekerül a CSV-be + árfolyam-bizonylat; a főkönyv kész,
  // csak a számla folyószámla-lezárása marad kézi).
  rlbDevizasMod: 'kihagy' | 'forint' | 'marad' = 'forint';
  // Melyik úton adjuk át az adatot az RLB-nek:
  //  'feladas' – kész könyvelés (Könyvelés → Automatikus könyvelés csv-ből). Gyors, de a
  //              devizás számla kiegyenlítését az a menüpont nem kezeli.
  //  'kivonat' – bankszámlatörténet (Bank könyvelése (RLB), típus: RLB(CSV)). Az RLB maga
  //              párosít és könyvel – így a devizás kiegyenlítés is automatikus.
  rlbUt: 'feladas' | 'kivonat' = 'feladas';
  rlbUtValt(ut: 'feladas' | 'kivonat') {
    this.rlbUt = ut;
    if (ut === 'feladas' && this.rlbDevizasMod === 'marad') this.rlbDevizasMod = 'forint';
    if (ut === 'kivonat' && this.rlbDevizasMod === 'forint') this.rlbDevizasMod = 'kihagy';
  }
  // A részletes lista csak megtörtént export után jelenik meg; az időszak devizás
  // tételeit viszont MÁR AZ EXPORT ELŐTT megnézzük, hogy ne utólag derüljön ki, mi maradt ki.
  rlbExportalt = false;
  rlbNyit() {
    this.rlbTartomany = { tol: this.szinkronTartomany.tol || '', ig: this.szinkronTartomany.ig || '' };
    this.rlbDevizasok = [];
    this.rlbExportalt = false;
    this.rlbModal = true;
    this.rlbDevizasBetolt();
    this.feltetelekBetolt();
  }
  async rlbExport() {
    if (!this.rlbTartomany.tol || !this.rlbTartomany.ig) { this.hiba('Add meg a kezdő és a záró dátumot.'); return; }
    if (this.rlbTartomany.tol > this.rlbTartomany.ig) { this.hiba('A kezdő dátum nem lehet későbbi a zárónál.'); return; }
    if (this.rlbUt === 'kivonat') { await this.rlbKivonatExport(); return; }
    this.rlbFut = true;
    try {
      const p = new URLSearchParams();
      if (this.szuro.bank_id) p.set('bank_id', this.szuro.bank_id);
      p.set('datumtol', this.rlbTartomany.tol);
      p.set('datumig', this.rlbTartomany.ig);
      p.set('devizas', this.rlbDevizasMod);
      const url = `${this.base}/${this.aktiv.ugyfelId}/rlb-export?${p.toString()}`;
      const resp = await firstValueFrom(this.http.get(url, { responseType: 'blob', observe: 'response' }));
      const blob = resp.body as Blob;
      if (!blob || blob.size === 0) { this.hiba('Nincs exportálható (kontírozott) banki tétel a megadott időszakban.'); return; }
      const db = resp.headers.get('X-Rlb-Tetel') || '?';
      const devizasDb = Number(resp.headers.get('X-Rlb-Devizas-Kihagyva') || 0);
      const atvDb = Number(resp.headers.get('X-Rlb-Atvezetes') || 0);
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `rlb_bank_${this.rlbTartomany.tol}_${this.rlbTartomany.ig}.csv`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(a.href);
      // Devizás kiegyenlítés esetén a modál NYITVA marad: ott sorolja fel, mit kell
      // kézzel rögzíteni az RLB-ben (a CSV ezeket nem tartalmazza).
      this.rlbExportalt = true;
      if (devizasDb > 0) {
        await this.rlbDevizasBetolt();
        this.ok(this.rlbDevizasMod === 'forint'
          ? `RLB export kész: ${db} banki tétel. ${devizasDb} devizás tétel forintosítva ment – a számlák kiegyenlítését az RLB-ben jelöld le.`
          : `RLB export kész: ${db} banki tétel${atvDb ? `, benne ${atvDb} devizás átvezetés` : ''}. `
            + `${devizasDb} devizás kiegyenlítés az átvezető kivonatba megy – lásd alább.`);
      } else {
        this.rlbModal = false;
        this.ok(`RLB export kész: ${db} banki tétel letöltve.`);
      }
    } catch (e: any) {
      this.hiba(e?.error?.error || 'Az RLB export nem sikerült.');
    } finally { this.rlbFut = false; }
  }

  // Bankszámlatörténet az RLB saját bankfeldolgozójának (RLB(CSV) típus). Nem kész
  // könyvelés: a párosítást és a könyvelést az RLB végzi – ezért kezeli a devizás
  // kiegyenlítést is. A partnernevet az alias-táblán átengedve, a már ismert
  // számlaszámot a közlemény elejére írva adjuk át, hogy az automata párosítás fogja.
  async rlbKivonatExport() {
    this.rlbFut = true;
    try {
      const p = new URLSearchParams();
      if (this.szuro.bank_id) p.set('bank_id', this.szuro.bank_id);
      p.set('datumtol', this.rlbTartomany.tol);
      p.set('datumig', this.rlbTartomany.ig);
      p.set('devizas', this.rlbDevizasMod === 'marad' ? 'marad' : 'kihagy');
      const url = `${this.base}/${this.aktiv.ugyfelId}/rlb-kivonat?${p.toString()}`;
      const resp = await firstValueFrom(this.http.get(url, { responseType: 'blob', observe: 'response' }));
      const blob = resp.body as Blob;
      if (!blob || blob.size === 0) { this.hiba('Nincs banki tétel a megadott időszakban.'); return; }
      const db = resp.headers.get('X-Rlb-Tetel') || '?';
      const biz = resp.headers.get('X-Rlb-Bizonylatszam') || '0';
      const szla = resp.headers.get('X-Rlb-Bankszla') || '';
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `bank_${szla}_${this.rlbTartomany.tol}_${this.rlbTartomany.ig}.csv`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(a.href);
      this.rlbModal = false;
      const kihagyva = Number(resp.headers.get('X-Rlb-Devizas-Kihagyva') || 0);
      this.ok(`Bankkivonat kész: ${db} tétel (${biz} tételen a számlaszám is rajta van a közleményben)`
        + (kihagyva ? `; ${kihagyva} devizás kiegyenlítés az átvezetőre megy.` : '.'));
    } catch (e: any) {
      // A blob-válasz miatt a hibaüzenet is blobként jön – kiolvassuk.
      let uzenet = 'A kivonat letöltése nem sikerült.';
      try { const szoveg = await (e?.error as Blob)?.text?.(); if (szoveg) uzenet = JSON.parse(szoveg).error || uzenet; } catch { /* marad az alap */ }
      this.hiba(uzenet);
    } finally { this.rlbFut = false; }
  }

  // A tartomány bármely változására frissítjük a panelt ÉS a feltétel-javaslatokat, hogy a
  // képernyő és a letöltött fájl mindig ugyanarról az időszakról szóljon. Rövid késleltetéssel,
  // hogy a dátum gépelése közben ne indítson tucatnyi lekérést.
  private tartomanyIdozito: any = null;
  tartomanyValt() {
    clearTimeout(this.tartomanyIdozito);
    this.tartomanyIdozito = setTimeout(() => this.rlbDevizasBetolt(), 300);
  }

  async rlbDevizasBetolt() {
    this.feltetelekBetolt();
    if (!this.rlbTartomany.tol || !this.rlbTartomany.ig) { this.rlbDevizasok = []; return; }
    try {
      const p = new URLSearchParams();
      if (this.szuro.bank_id) p.set('bank_id', this.szuro.bank_id);
      p.set('datumtol', this.rlbTartomany.tol);
      p.set('datumig', this.rlbTartomany.ig);
      const r: any = await this.get(`/${this.aktiv.ugyfelId}/rlb-devizas-kiegyenlitesek?${p.toString()}`);
      // (a lista mindkét módban ugyanaz: kihagyásnál a teljes kézi rögzítéshez,
      //  forintosításnál a folyószámla-lezáráshoz kellenek a számok)
      this.rlbDevizasok = r?.tetelek || [];
    } catch { this.rlbDevizasok = []; }
  }

  /* ── Párosítási feltétel-javaslatok ─────────────────────────────────────────
     A kivonat-formátumban nincs főkönyvi oszlop: amit az RLB nem tud számlához párosítani
     (bankköltség, adó, egyéb), annál üresen marad a „Nettó fsz.". Erre valók a program
     párosítási feltételei – itt kigyűjtjük, pontosan melyek kellenek, a mi kontírunkból. */
  feltetelek: any[] = [];
  feltetelekFut = false;
  async feltetelekBetolt() {
    if (!this.rlbTartomany.tol || !this.rlbTartomany.ig) return;
    this.feltetelekFut = true;
    try {
      const p = new URLSearchParams();
      if (this.szuro.bank_id) p.set('bank_id', this.szuro.bank_id);
      p.set('datumtol', this.rlbTartomany.tol);
      p.set('datumig', this.rlbTartomany.ig);
      const r: any = await this.get(`/${this.aktiv.ugyfelId}/rlb-parositasi-feltetelek?${p.toString()}`);
      this.feltetelek = r?.feltetelek || [];
    } catch { this.feltetelek = []; }
    finally { this.feltetelekFut = false; }
  }
  get feltetelekFontos() { return this.feltetelek.filter((f) => !f.partnerszamla); }
  feltetelekMasol() {
    const sorok = ['Típus\tPartner\tNettó főkönyvi\tIrány\tDb'];
    for (const f of this.feltetelek) sorok.push([f.tipus, f.partner_nev, f.fokonyvi_szam, f.irany, f.db].join('\t'));
    navigator.clipboard?.writeText(sorok.join('\n'))
      .then(() => this.ok('A feltétel-javaslatok a vágólapon.'))
      .catch(() => this.hiba('Nem sikerült a vágólapra másolni.'));
  }

  /* ── EUR átvezető kivonat ────────────────────────────────────────────────────
     A devizás fizetést egy technikai deviza-„bankon" (alap: 3868) vezetjük át, és arra
     adunk kivonatot: feltöltés + kifizetés párokban. Így az RLB SAJÁT devizás
     bankfeldolgozója egyenlíti ki a számlát, és számolja el az árfolyam-különbözetet. */
  /*  Az átvezető „bankos" automata devizás kiegyenlítést KIVEZETTÜK.
   *
   *  Az RLB a technikai deviza-számláról átlagárfolyamon vezet ki, ezért vagy a forint
   *  egyenleg nem nullázódott a számlán, vagy – ha közös árfolyammal töltöttük fel –
   *  kettős árfolyam-különbözet keletkezett. A devizás banki tételek forintosítva mennek
   *  át (a soron ott a deviza összeg és az árfolyam), a számlák párosítását pedig a
   *  könyvelő végzi az RLB pénzügyi nyilvántartásában.
   *
   *  A szerveroldali végpontok (rlb-deviza-kivonat, rlb-deviza-atvezetes-feladas)
   *  megmaradtak, de a felület nem hívja őket.
   */

  // A kézi rögzítéshez tabulátorral tagolt sorok – vágólapra másolva bárhova beilleszthető.
  rlbDevizasMasol() {
    const sorok = ['Dátum\tPartner\tSzámla\tDeviza\tDeviza összeg\tForint\tÁrfolyam\tKönyv szerinti Ft\tÁrf. különbözet\tFőkönyvi'];
    for (const t of this.rlbDevizasok) {
      for (const x of (t.tetelek || [])) {
        sorok.push([t.datum, x.partner_nev, x.bizonylatszam, x.deviza, x.deviza_osszeg, x.forint,
          x.arfolyam, x.konyv_szerinti_forint, x.arfolyam_kulonbozet, `${t.partner_fokonyvi}/${x.eredmeny_szamla || ''}`].join('\t'));
      }
    }
    navigator.clipboard?.writeText(sorok.join('\n'))
      .then(() => this.ok('A devizás kiegyenlítések a vágólapon.'))
      .catch(() => this.hiba('Nem sikerült a vágólapra másolni.'));
  }

  // ----- kontír-szabályok -----
  async szabalyokNyit() {
    this.szabalyModal = true;
    try { this.szabalyok = await this.get(`/${this.aktiv.ugyfelId}/szabalyok`); } catch { this.szabalyok = []; }
  }
  szabalyUj() { this.ujSzabaly = { nev: '', mezo: 'partner_nev', operator: 'tartalmaz', minta: '', irany: 'barmi', tipus: 'szallito', ellenszamla: '', prioritas: 60, intezmenyi: false, aktiv: true }; }
  szabalySzerkeszt(s: any) { this.ujSzabaly = { ...s, aktiv: s.aktiv !== 0 }; }
  async szabalyMent() {
    try { await this.post(`/${this.aktiv.ugyfelId}/szabaly`, this.ujSzabaly); this.ujSzabaly = null; this.szabalyok = await this.get(`/${this.aktiv.ugyfelId}/szabalyok`); this.ok('Szabály mentve.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni a szabályt.'); }
  }
  async szabalyTorol(s: any) {
    try { await this.del(`/${this.aktiv.ugyfelId}/szabaly/${s.id}`); this.szabalyok = this.szabalyok.filter((x) => x.id !== s.id); }
    catch { this.hiba('Nem sikerült törölni.'); }
  }

  // ----- kézi számla-felvétel / szerkesztés -----
  ujSzamlaNyit(b?: any) { this.ujSzamla = b ? { ...b } : { iban: '', bank_nev: '', banktipus: 'bank', fokonyvi_szam: '3841' }; }
  async szamlaMent() {
    try { await this.post(`/${this.aktiv.ugyfelId}/szamla`, this.ujSzamla); this.ujSzamla = null; await this.betolt(); this.ok('Mentve.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }
  async szamlaTorol(b: any) {
    const a = await this.alert.create({ header: 'Törlés', message: `${b.iban} törlése?`, buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive' }] });
    await a.present(); const { role } = await a.onDidDismiss(); if (role !== 'destructive') return;
    try { await this.del(`/${this.aktiv.ugyfelId}/szamla/${b.id}`); await this.betolt(); } catch { this.hiba('Nem sikerült törölni.'); }
  }

  fmt(n: any) { const v = Number(n) || 0; return v.toLocaleString('hu-HU', { maximumFractionDigits: 2 }); }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2200, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 3000, color: 'danger' })).present(); }
  // Nem hiba, de nem is siker: az adatfolyam-elakadás csak FELTÉTELESEN baj (ha volt azóta forgalom),
  // ezért sárga és hosszabban látszik – el kell tudni olvasni a teendőt.
  private async figyelem(m: string) { (await this.toast.create({ message: m, duration: 8000, color: 'warning' })).present(); }
}
